export default __webpack_public_path__ + "static/media/ME-PMP2.76044f04.png";